module.exports = __webpack_public_path__ + "img/rise-3@2x.d1b8f614.png";